declare namespace $ {

	export class $mol_icon_comment_quote extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=quote.view.tree.d.ts.map